/**
 * Minimal quadrant accents: short strokes aimed toward the hub (instrument / calibration read).
 */

/**
 * @param {number} hubCx
 * @param {number} hubCy
 * @param {number} rimPx - point on diagonal (outer anchor)
 * @param {number} rimPy
 * @param {number} tickLen - length inward toward hub
 * @returns {{ x1: number, y1: number, x2: number, y2: number }}
 */
export function ontologyRadialTickTowardHub(hubCx, hubCy, rimPx, rimPy, tickLen) {
  const vx = rimPx - hubCx;
  const vy = rimPy - hubCy;
  const L = Math.hypot(vx, vy);
  const ux = vx / L;
  const uy = vy / L;
  return {
    x1: rimPx,
    y1: rimPy,
    x2: rimPx - ux * tickLen,
    y2: rimPy - uy * tickLen,
  };
}
